const React = require('react');

module.exports = (props) => {
  return (
    <svg
      viewBox="0 0 10 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={'dB w10 abs sr20*2 st50%*2 xY-50%*2 '
        + (props.className || '')}
    >
      <path d="M5 8L0 -4.37114e-07L10 0L5 8Z"/>
    </svg>
  );
};
